import {apiWithToken} from '../../../systems/api/index';
import {API_URL} from '../../../systems/globalContant/index';

export default {
    addInvoiceCode2Transaction: (datas) => apiWithToken.post(API_URL.ADD_INVOICE_CODE_2_TRANSACTION.replace("{id_transaction}", datas.id_transaction), {...datas}, {loading: false}),
};